// For details, see: ./src/assets/special-countries/README.md
export const SPECIAL_COUNTRIES = ['zh-TW'];
